import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Form, Button, Spinner } from 'react-bootstrap';
import { ArrowLeft, Mail } from 'lucide-react';
import "../../../assets/css/Drivers/DriverAuth/DriverForgotPassword.css";
import forgot from "../../../assets/images/forgot.png";
import axios from "axios";
import AppContext from "../../../context/AppContext";

const DriverForgotPassword = () => {
  const { baseUrl, RegExpChecker } = useContext(AppContext);
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [errors, setErrors] = useState({
    email: "",
  });
  const isFormValid =
    email &&
    !errors.email;

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!isFormValid) return;

    setLoading(true);

    const formData = new FormData();
    formData.append("email", email);
    formData.append("user_type", "driver");

    axios
      .post(`${baseUrl}/general/forgotpassword/sendOtp`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        setLoading(false);
        console.log(response.data);
        if (response.data.success === true) {
          navigate('/driver-otp-verification', { state: { email } });
        } else {
          alert(response.data.message || "Email not found");
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        alert("Network Error! Please try again.");
      });
  };

  const handleBack = () => {
    navigate('/driver-login');
  };

  return (
    <div className="DriverForgotPassword-wrapper">
      <Container fluid className="DriverForgotPassword-container">
        <Row>
          <Col xs={12}>
            <Button
              variant="light"
              onClick={handleBack}
              className="DriverForgotPassword-back-btn"
            >
              <ArrowLeft size={20} />
            </Button>

            <div className="DriverForgotPassword-image-container">
              <div className="DriverForgotPassword-image-box">
                <img
                  src={forgot}
                  alt="Forgot Password"
                  className="DriverForgotPassword-image"
                />
              </div>
            </div>

            <div className="DriverForgotPassword-content">
              <h2 className="DriverForgotPassword-title">
                Forgot Your Password?
              </h2>
              <p className="DriverForgotPassword-subtitle">
                Enter your email, and we'll send reset instructions.
              </p>

              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-4">
                  <Form.Label className="DriverForgotPassword-label">
                    Email
                  </Form.Label>
                  <div className="DriverForgotPassword-input-wrapper">
                    <Mail size={18} className="DriverForgotPassword-input-icon" />
                    <Form.Control
                      type="email"
                      placeholder="Enter email"
                      value={email}
                      onChange={(e) => {
                        const value = e.target.value;
                        setEmail(value);

                        const regError = RegExpChecker("email", value);

                        setErrors((prev) => ({
                          ...prev,
                          email: value && regError ? regError : "",
                        }));
                      }}
                      required
                      className="DriverForgotPassword-input"
                    />
                  </div>
                  {errors.email && (
                    <small className="text-danger d-block mt-1 text-start text-nowrap">{errors.email}</small>
                  )}
                </Form.Group>

                <div className="DriverForgotPassword-button-container">
                  <Button
                    type="submit"
                    className="DriverForgotPassword-submit-btn w-100"
                    disabled={loading || !isFormValid}
                  >
                    {loading ? (
                      <Spinner as="span" animation="border" size="sm" role="status" />
                    ) : (
                      "Send"
                    )}
                  </Button>
                </div>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default DriverForgotPassword;